import React from 'react';
import { Input, Modal } from 'semantic-ui-react';

import Button from '../../../components/Button';
import { toAbsoluteUrl } from '../../../utils/toAbsoluteUrl';

type Props = {
  open: boolean;
  onClose: () => void;
  chargeLink: string;
  paymentMethod: 'PIX' | 'BOLETO';
  onCopy: () => void;
};

const SuccessModal: React.FC<Props> = ({ open, onClose, chargeLink, paymentMethod, onCopy }) => {
  const displayLink =
    typeof chargeLink === 'string' && chargeLink.trim()
      ? toAbsoluteUrl(chargeLink)
      : chargeLink;

  return (
    <Modal open={open} onClose={onClose} size="tiny" closeIcon>
      <Modal.Header>Cobrança criada com sucesso!</Modal.Header>
      <Modal.Content>
        <p>Método selecionado: <strong>{paymentMethod}</strong></p>
        <p>Link da cobrança:</p>
        <Input fluid value={displayLink} readOnly />
      </Modal.Content>
      <Modal.Actions>
        <Button type="button" text="Copiar link" light onClick={onCopy} />
        <Button type="button" text="Fechar" onClick={onClose} />
      </Modal.Actions>
    </Modal>
  );
};

export default SuccessModal;

